import { SelectState } from '../../../../../../components/select/types/state';
import { SelectVariantType } from '../../../../../../designSystem/reloaded/commons/components/select/variants';
import { commonStyles } from '../commonStyles';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [SelectVariantType.REGULAR]: {
            [SelectState.DEFAULT]: {
                ...commonStyles(FOUNDATIONS, FONT, {}),
                showIllustration: false,
                showLeftIcon: false,
            },
            [SelectState.DEFAULT_FILLED]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    icon: {
                        color: FOUNDATIONS.color_comp_forms_select_icon,
                    },
                    label: {
                        color: FOUNDATIONS.color_comp_forms_select_filled_font,
                    },
                }),
                showIllustration: false,
                showLeftIcon: false,
            },
            [SelectState.DISABLED]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    parentContainer: {
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        cursor: 'default',
                    },
                    icon: {
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                    label: {
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                }),
                showIllustration: false,
                showLeftIcon: false,
            },
            [SelectState.DISABLED_FILLED]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    parentContainer: {
                        background_color: FOUNDATIONS.color_accent_disabled_bg_200,
                        cursor: 'default',
                    },
                    icon: {
                        color: FOUNDATIONS.color_accent_disabled_icon_50,
                    },
                    label: {
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                }),
                showIllustration: false,
                showLeftIcon: false,
            },
        },
    };
};
//# sourceMappingURL=regular.js.map